import { useCallback } from 'react'
import { useMutation } from '@apollo/client/react'
import { AdminAPI, getFragment, SharedAPI } from '@guestgoodie/graphql'

import { useCurrentUser } from '@/features/user'

export function useMarkAllAsRead() {
  const { user } = useCurrentUser()

  const [markAllRead, { client, loading }] = useMutation(
    AdminAPI.simpleFeedback.MARK_ALL_AS_READ
  )

  const markAllAsRead = useCallback(() => {
    markAllRead({
      onCompleted() {
        const cache = client.cache

        cache.updateQuery(
          { query: AdminAPI.simpleFeedback.UNREAD_COUNT },
          data => {
            if (!data) return

            return {
              unreadFeedbackCount: 0
            }
          }
        )

        cache.updateQuery(
          {
            query: AdminAPI.simpleFeedback.QUERY,
            variables: {
              page: 0,
              pageSize: 25,
              filter: {},
              withStay: true,
              withSpace: true
            }
          },
          data => {
            if (!data) return

            const items = getFragment(
              SharedAPI.simpleFeedback.SIMPLE_FEEDBACK_FRAGMENT,
              data.querySimpleFeedbacks.items
            )

            return {
              querySimpleFeedbacks: {
                ...data?.querySimpleFeedbacks,
                items: items.map(function (item) {
                  if (item.isRead) return item

                  return {
                    ...item,
                    isRead: true,
                    readByUserId: user.id,
                    readAt: new Date().toISOString()
                  }
                })
              }
            }
          }
        )
      }
    })
  }, [client, user, markAllRead])

  return {
    markAllAsRead,
    loading
  }
}
